import React from 'react';
import Icon from './Icon';


const QuestionCard = (props) => {
    return (
        <div className="question-card">
            <div className="container">
                <span className="question-asked">{props.question}</span>
                <div className="row answer">
                    <input
                        type="text"
                        className="bottom-bar-style"
                        value={props.answer}
                        onChange={(event) => props.handleMessage(event, props.index)}
                        onKeyPress={(event) => props.handleKeyPress(event, props.index)}
                    />
                </div>
                <span
                    className={`row justify-end full text small medium-grey pr-32 ${props.answer.length >= props.lengthLimit ? 'good' : ''}`}>(minimum {props.lengthLimit} caractères&nbsp;{props.answer.length >= props.lengthLimit ?
                    <Icon type="check-circle"/> : ''})</span>
            </div>
        </div>
    )
};

export default QuestionCard;
